<template>
  <div>
    <b-modal id="modalEditSubnetsDHCPv6" ref="modalEditSubnetsDHCPv6" :title="$t('Subnet DHCPv6')" hide-footer size="lg">
      <div v-if="editItem">
        <b-tabs pills card content-class="mt-3">
          <b-tab :title="$t('Main parameters')" active>
            <b-form-group label-align="right" v-if="isEdit" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.id" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Subnet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.subnet" aria-describedby="inputFeedbackSubnet" :state="editItem.subnet.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackSubnet">
                  {{ $t('Enter IPv6') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Client classification')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem['client-class']" :options="clientClassification"/>
            </b-form-group>
            <b-form-group label-align="right" label="Interface" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.interface"/>
            </b-form-group>
            <b-form-group label-align="right" label="Interface-id" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem['interface-id']"/>
            </b-form-group>
            <b-card class="mb-3">
              <b-form-group :label="$t('Pools')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <md-button class="md-raised" style="float: right; width: 100px" @click="swohAddPools">{{ $t('Add') }}</md-button>
              </b-form-group>
              <b-table small striped hover :items="editItem.pools" :fields="poolsFields">
                <template v-slot:cell(actions)="row">
                  <b-button size="sm" @click.stop="editPools(row)" id="transparent">
                    <b-img :src='editImage' style="width: 20px"/>
                  </b-button>
                  <b-button size="sm" @click.stop="deletePools(row)" id="transparent">
                    <b-img :src='deleteImage' style="width: 20px"/>
                  </b-button>
                </template>
              </b-table>
            </b-card>
            <b-card class="mb-3">
              <b-form-group :label="$t('Delegated prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <md-button class="md-raised" style="float: right; width: 100px" @click="swohAddPd_pools">{{ $t('Add') }}</md-button>
              </b-form-group>
              <b-table small striped hover :items="editItem['pd-pools']" :fields="pd_poolsFields">
                <template v-slot:cell(actions)="row">
                  <b-button size="sm" @click.stop="editPd_pools(row)" id="transparent">
                    <b-img :src='editImage' style="width: 20px"/>
                  </b-button>
                  <b-button size="sm" @click.stop="deletePd_pools(row)" id="transparent">
                    <b-img :src='deleteImage' style="width: 20px"/>
                  </b-button>
                </template>
              </b-table>
            </b-card>
            <b-card class="mb-3">
              <b-form-group :label="$t('Option-data')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <md-button class="md-raised" style="float: right; width: 100px" @click="showAddOptionData">{{ $t('Add') }}</md-button>
              </b-form-group>
              <b-table small striped hover :items="editItem['option-data']" :fields="optionDataFields">
                <template v-slot:cell(actions)="row">
                  <b-button size="sm" @click.stop="editOptionData(row)" id="transparent">
                    <b-img :src='editImage' style="width: 20px"/>
                  </b-button>
                  <b-button size="sm" @click.stop="deleteOptionData(row)" id="transparent">
                    <b-img :src='deleteImage' style="width: 20px"/>
                  </b-button>
                </template>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab :title="$t('Additional')">
            <b-form-group label-align="right" label="Preferred life time" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem['preferred-lifetime']" aria-describedby="inputFeedbackPreferredLifeTime" :state="editItem['preferred-lifetime'] > 0"/>
              <b-form-invalid-feedback id="inputFeedbackPreferredLifeTime">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="Rebind timer" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem['rebind-timer']" aria-describedby="inputFeedbackRebindTimer" :state="editItem['rebind-timer'] > 0"/>
              <b-form-invalid-feedback id="inputFeedbackRebindTimer">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="Renew timer" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem['renew-timer']" aria-describedby="inputFeedbackRenewTimer" :state="editItem['renew-timer'] > 0"/>
              <b-form-invalid-feedback id="inpu4tFeedbackRenewTimer">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="Valid life time" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem['valid-lifetime']" aria-describedby="inputFeedbackValidLifeTime" :state="editItem['valid-lifetime'] > 0"/>
              <b-form-invalid-feedback id="inputFeedbackValidLifeTime">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="T1 percent" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem['t1-percent']" aria-describedby="inputFeedbackT1Percent" :state="editItem['t1-percent'] > 0"/>
              <b-form-invalid-feedback id="inputFeedbackT1Percent">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="T2 percent" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem['t2-percent']" aria-describedby="inputFeedbackT2Percent" :state="editItem['t2-percent'] > 0"/>
              <b-form-invalid-feedback id="inputFeedbackT2Percent">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="Calculate tee times" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem['calculate-tee-times']"/>
            </b-form-group>
            <b-form-group label-align="right" label="Rapid commit" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem['rapid-commit']"/>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="save" @cancel="$refs.modalEditSubnetsDHCPv6.hide" />

      </div>
    </b-modal>

    <b-modal hide-footer id="modalPd_pools" ref="modalPd_pools" :title="$t('Delegated prefix')">
      <b-form-group label-align="right" :label="$t('Prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="selectPd_pools.prefix" aria-describedby="inputFeedbackPrefix" :state="selectPd_pools.prefix.length > 0"/>
        <b-form-invalid-feedback id="inputFeedbackPrefix">
            {{ $t('Enter IPv6') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Prefix len')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="selectPd_pools['prefix-len']" aria-describedby="inputFeedbackPrefixLen" :state="selectPd_pools['prefix-len'] > 0"/>
        <b-form-invalid-feedback id="inputFeedbackPrefixLen">
            {{ $t('Enter number') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Delegated len')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="selectPd_pools['delegated-len']" aria-describedby="inputFeedbackDelegatedLen" :state="selectPd_pools['delegated-len'] > 0"/>
        <b-form-invalid-feedback id="inputFeedbackDelegatedLen">
            {{ $t('Enter number') }}
        </b-form-invalid-feedback>
      </b-form-group>

      <modal-ok-cancel @save="savePd_pools" @cancel="$bvModal.hide('modalPd_pools')" />

    </b-modal>

    <b-modal hide-footer id="modalPools" ref="modalPools" :title="$t('Pools')">
      <b-form-group label-align="right" :label="$t('Pool')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-input type="text" v-model="selectPools.pool" aria-describedby="inputFeedbackPool" :state="selectPools.pool.length > 0"/>
          <b-input-group-append>
            <span id="tooltip">
              <b-img :src="questionImage"/>
            </span>
            <b-tooltip target="tooltip" triggers="hover">
              {{ $t('Examples: cafe::/96, cafe::0-cafe-::10') }}
            </b-tooltip>
          </b-input-group-append>
          <b-form-invalid-feedback id="inputFeedbackPool">
              {{ $t('Enter IPv6') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>

      <modal-ok-cancel @save="savePools" @cancel="$bvModal.hide('modalPools')" />

    </b-modal>
    <modalOptionData
      :selectSubnet="selectSubnet"
      :editItem="editItem"
      :selectOptionData="selectOptionData"/>
  </div>
</template>

<script>
import modalOptionData from '../modalOptionData'

export default {
  components: {
    modalOptionData
  },
  props: {
    editItem: null,
    isEdit: null
  },
  data () {
    return {
      selectSubnet: {
        'isSubnet': false
      },
      selectOptionData: {
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      },
      optionDataFields: [
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'code', label: this.$i18n.t('Code'), sortable: true},
        {key: 'space', label: this.$i18n.t('Space'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      numPools: 1000000,
      numPdPools: 1000000,
      questionImage: require('@/assets/img/question.png'),
      selectPools: {
        'pool': '',
        'option-data': []
      },
      selectPd_pools: {
        'delegated-len': '',
        'option-data': [],
        'prefix': '',
        'prefix-len': '',
        'user-context': {'purpose': 'For CPE devices'}
      },
      poolsFields: [
        {key: 'pool', label: this.$i18n.t('Pool'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      pd_poolsFields: [
        {key: 'prefix', label: this.$i18n.t('Prefix'), sortable: true},
        {key: 'prefix-len', label: this.$i18n.t('Prefix len'), sortable: true},
        {key: 'delegated-len', label: this.$i18n.t('Delegated len'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    async save () {
      if (!this.editItem.subnet) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return
      } else {
        if (!this.validationIPv6subnet()) {
          return
        }
      }
      if (!this.editItem['preferred-lifetime']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Preferred life time'), 'Error')
        return
      }
      if (!this.editItem['rebind-timer']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Rebind timer'), 'Error')
        return
      }
      if (!this.editItem['renew-timer']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Renew timer'), 'Error')
        return
      }
      if (!this.editItem['valid-lifetime']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Valid life time'), 'Error')
        return
      }
      if (!this.editItem['t1-percent']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field T1 percent'), 'Error')
        return
      }
      if (!this.editItem['t2-percent']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field T2 percent'), 'Error')
        return
      }

      let reserveEditItem = JSON.parse(JSON.stringify(this.editItem))
      let DHCP = {
        'is_test_only': true,
        'loop_count_timeout': 35,
        'config': {}
      }
      let DHCPv6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      for (let el of this.editItem.pools) {
        delete el.numPools
        delete el.isEdit
      }
      for (let el of this.editItem['option-data']) {
        delete el.isEdit
        delete el.numOptionData
      }
      if (this.editItem['pd-pools']) {
        for (let el of this.editItem['pd-pools']) {
          el['prefix-len'] = Number(el['prefix-len'])
          el['delegated-len'] = Number(el['delegated-len'])
          delete el.isEdit
          delete el.numPdPools
        }
      }
      if (this.isEdit) {
        for (let el of DHCPv6.arguments.Dhcp6.subnet6) {
          if (this.editItem.id === el.id) {
            el['client-class'] = this.editItem['client-class']
            el['pd-pools'] = this.editItem['pd-pools']
            el['pools'] = this.editItem.pools
            el['subnet'] = this.editItem.subnet
            el['t1-percent'] = Number(this.editItem['t1-percent'])
            el['t2-percent'] = Number(this.editItem['t2-percent'])
            el['renew-timer'] = Number(this.editItem['renew-timer'])
            el['valid-lifetime'] = Number(this.editItem['valid-lifetime'])
            el['preferred-lifetime'] = Number(this.editItem['preferred-lifetime'])
            el['rebind-timer'] = Number(this.editItem['rebind-timer'])
            el['calculate-tee-times'] = this.editItem['calculate-tee-times']
            el['rapid-commit'] = this.editItem['rapid-commit']
            el['option-data'] = this.editItem['option-data']
            el['interface'] = this.editItem.interface
            el['interface-id'] = this.editItem['interface-id']
          }
        }
      } else {
        let id = [0]
        for (let el of DHCPv6.arguments.Dhcp6.subnet6) {
          id.push(el.id)
        }
        for (let el of DHCPv6.arguments.Dhcp6['shared-networks']) {
          if (el.subnet6.length > 0) {
            for (let elSub of el.subnet6) {
              id.push(elSub.id)
            }
          }
        }
        this.editItem.id = Math.max.apply(null, id) + 1
        this.editItem['t1-percent'] = Number(this.editItem['t1-percent'])
        this.editItem['t2-percent'] = Number(this.editItem['t2-percent'])
        this.editItem['renew-timer'] = Number(this.editItem['renew-timer'])
        this.editItem['valid-lifetime'] = Number(this.editItem['valid-lifetime'])
        this.editItem['preferred-lifetime'] = Number(this.editItem['preferred-lifetime'])
        this.editItem['rebind-timer'] = Number(this.editItem['rebind-timer'])
        DHCPv6.arguments.Dhcp6.subnet6.push(this.editItem)
      }
      DHCP.config = DHCPv6.arguments
      await this.$store.dispatch('Settings/SAVE_DHCPV6', DHCP).then(response => {
        if (response.data.result === 0) {
          DHCP.is_test_only = false
          let response = this.$store.dispatch('Settings/SAVE_DHCPV6', DHCP)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
              this.$refs.modalEditSubnetsDHCPv6.hide()
              this.$root.$emit('makeToasts')
            }
          })
        } else {
          this.editItem = reserveEditItem
          this.$root.$emit('makeToasts', 'danger', response.data.text, 'Error')
        }
      })
    },
    savePd_pools () {
      if (!this.selectPd_pools.prefix) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return
      } else {
        if (!this.validationIPv6prefix()) {
          return
        }
      }
      if (!this.selectPd_pools['delegated-len']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Delegated len'), 'Error')
        return
      }
      if (!this.selectPd_pools['prefix-len']) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Prefix len'), 'Error')
        return
      }

      if (this.selectPd_pools.isEdit) {
        for (let el of this.editItem['pd-pools']) {
          if (this.selectPd_pools.numPdPools === el.numPdPools) {
            el['delegated-len'] = this.selectPd_pools['delegated-len']
            el.prefix = this.selectPd_pools.prefix
            el['prefix-len'] = this.selectPd_pools['prefix-len']
          }
        }
      } else {
        this.selectPd_pools.numPdPools = ++this.numPdPools
        this.editItem['pd-pools'].push(this.selectPd_pools)
      }
      this.$refs.modalPd_pools.hide()
    },
    swohAddPd_pools () {
      this.selectPd_pools = {
        'isEdit': false,
        'delegated-len': '',
        'option-data': [],
        'prefix': '',
        'prefix-len': '',
        'user-context': {'purpose': 'For CPE devices'}
      }
      this.$refs.modalPd_pools.show()
    },
    editPd_pools (row) {
      this.selectPd_pools = JSON.parse(JSON.stringify(row.item))
      this.selectPd_pools.isEdit = true
      this.$refs.modalPd_pools.show()
    },
    deletePd_pools (row) {
      this.editItem['pd-pools'] = this.editItem['pd-pools'].filter((value) => {
        return value !== row.item
      })
    },
    savePools () {
      if (!this.selectPools.pool) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return
      } else {
        if (!this.validationIPv6pool()) {
          return
        }
      }

      if (this.selectPools.isEdit) {
        for (let el of this.editItem.pools) {
          if (this.selectPools.numPools === el.numPools) {
            el.pool = this.selectPools.pool
          }
        }
      } else {
        this.selectPools.numPools = ++this.numPools
        this.editItem.pools.push(this.selectPools)
      }
      this.$refs.modalPools.hide()
    },
    swohAddPools () {
      this.selectPools = {
        'isEdit': false,
        'pool': '',
        'option-data': []
      }
      this.$refs.modalPools.show()
    },
    editPools (row) {
      this.selectPools = JSON.parse(JSON.stringify(row.item))
      this.selectPools.isEdit = true
      this.$refs.modalPools.show()
    },
    deletePools (row) {
      this.editItem.pools = this.editItem.pools.filter((value) => {
        return value !== row.item
      })
    },
    showAddOptionData () {
      this.selectOptionData = {
        'numOptionData': 0,
        'isEdit': false,
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      }
      this.$bvModal.show('modalOptionData')
    },
    editOptionData (row) {
      this.selectOptionData = JSON.parse(JSON.stringify(row.item))
      this.selectOptionData.isEdit = true
      this.$bvModal.show('modalOptionData')
    },
    deleteOptionData (row) {
      this.editItem['option-data'] = this.editItem['option-data'].filter((value) => {
        return value !== row.item
      })
    },
    validationIPv6subnet () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      if (!this.editItem.subnet.includes('/')) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in mask'), 'Error')
        return false
      }
      if (this.editItem.subnet.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationIPv6pool () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      if (!this.selectPools.pool.includes('/')) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in mask'), 'Error')
        return false
      }
      if (this.selectPools.pool.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationIPv6prefix () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      if (this.selectPd_pools.prefix.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    }
  },
  computed: {
    clientClassification () {
      let dhcp = this.$store.getters['Settings/DHCPV6']
      let option = []
      for (let el of dhcp.arguments.Dhcp6['client-classes']) {
        let newEl = {
          text: '',
          value: 0
        }
        newEl.text = el.name
        newEl.value = el.name
        option.push(newEl)
      }
      let newEl = {
        text: '---',
        value: ''
      }
      option.push(newEl)
      return option
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/DHCPv6/subnets/editModal.vue